module.exports = __webpack_public_path__ + "img/index-banner.70c0e6da.jpg";